import { render, staticRenderFns } from "./PerformanceDashboard.vue?vue&type=template&id=aa05209e&"
import script from "./PerformanceDashboard.vue?vue&type=script&lang=js&"
export * from "./PerformanceDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports